import { freightPickupAccessorialPresetIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteFreightPickupAccessorialPreset = {
  name: "deleteFreightPickupAccessorialPreset" as const,
  input: z.object({ id: freightPickupAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
